<template>
  <!-- <main class="main" v-if="!showLoader"> -->
  <HeaderPage />
  <router-view />
  <FooterPage />
  <ScrollTop />
  <!-- </main> -->
  <!-- <start-loader v-else></start-loader> -->
</template>

<script>
import HeaderPage from "./components/HeaderPager.vue";
import FooterPage from "./components/FooterPage.vue";
import ScrollTop from "./components/ScrollTop.vue";
// import StartLoader from "./components/StartLoader.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "App",
  components: { FooterPage, HeaderPage, ScrollTop },

  methods: {
    ...mapActions(["hidenLoader"]),
  },
  computed: {
    ...mapGetters(["showLoader"]),
  },

  mounted() {
    this.hidenLoader();
  },
};
</script>
<style>
@import url("assets/css/variable.css");
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-out;
}
</style>
